import { apiLabs } from '../../api'

const getEggsShells = async () => {
	const res = await apiLabs.get('separa/painel_cascas')
	return res
}

export default getEggsShells 